import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import CategoryService from "@/services/api/category";
import type { Category, CategoryParams } from "@/types/category";

export interface CategoryState {
  categories: Category[];
  totalRecords: number;
  isFetching: boolean;
}

const initialState: CategoryState = {
  categories: [],
  totalRecords: 0,
  isFetching: false,
};

export const getCategories = createAsyncThunk(
  "category/getCategories",
  async (params: CategoryParams | undefined) => CategoryService.getAllCategories(params),
);

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCategories.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getCategories.fulfilled, (state, action) => {
        state.isFetching = false;
        state.categories = action.payload?.data?.results ?? [];
        state.totalRecords = action.payload?.data?.totalRecord ?? 0;
      })
      .addCase(getCategories.rejected, (state) => {
        state.isFetching = false;
      });
  },
});

export default categorySlice.reducer;
